import { render, staticRenderFns } from "./SqlGenerator.vue?vue&type=template&id=9b55a55e"
import script from "./SqlGenerator.vue?vue&type=script&lang=js"
export * from "./SqlGenerator.vue?vue&type=script&lang=js"
import style0 from "./SqlGenerator.vue?vue&type=style&index=0&id=9b55a55e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports